<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Update Details"
              bc1="App"
              bc2="Channel"
              bc3="Update"
              path="channel"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <ValidationObserver
                      ref="observer"
                      tag="form"
                      v-slot="{ invalid, validate }"
                  >
                    <form
                        class="form form-horizontal"
                        @submit.prevent="validate().then(sendCall)"
                    >
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="name-icon">Name</label>
                            </div>
                            <div class="col-sm-9">
                              <ValidationProvider
                                  name="Name"
                                  ref="name"
                                  rules="required"
                                  v-slot="{ errors }"
                              >
                                <div class="input-group">

                                  <input
                                      type="text"
                                      v-model="name"
                                      id="name-icon"
                                      class="form-control"
                                      :class="errors[0] ? 'is-invalid' : ''"
                                      name="name"
                                      placeholder="Name"
                                      v-validate="'required'"
                                  />
                                </div>
                                <small
                                    class="block text-red-600 text-xs absolute bottom-0 left-0"
                                    style="color:#EA5455"
                                >{{ errors[0] }}</small
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="type-icon">Type</label>
                            </div>
                            <div class="col-sm-9">
                              <ValidationProvider
                                  name="type"
                                  ref="type"
                                  rules="required"
                                  v-slot="{ errors }"
                              >
                                <div class="input-group">
                                  <select class="form-control" v-model="type">
                                    <option :value="null" disabled>Select Type</option>
                                    <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
                                  </select>
                                </div>
                                <small
                                    class="block text-red-600 text-xs absolute bottom-0 left-0"
                                    style="color:#EA5455"
                                >{{ errors[0] }}</small
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 d-flex mt-5">
                          <button
                              type="submit"
                              class="btn btn-primary mr-1 d-flex"
                              :disabled="loading"
                          >
                            <Loader :loading="loading" :size="size"></Loader>
                            Submit
                          </button>
                          <button
                              type="button"
                              class="btn btn-gradient-secondary"
                              @click="$router.back()"
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    CommandIcon,
    ValidationObserver,
    ValidationProvider
  },
  mounted() {
    this.terminalId = this.$route.params.terminalId
    var merchantChannelUpdate = this.$store.getters.getByKey(
        "merchantChannelUpdate"
    );
    this.channelId =  merchantChannelUpdate.row.id
    this.name =  merchantChannelUpdate.row.name
    this.type =  merchantChannelUpdate.row.type
    this.index = merchantChannelUpdate.index;
    this.id = merchantChannelUpdate.row.id;
  },
  data() {
    return {
      name: "",
      type: null,
      types: [
        {
          id: 1,
          name: "Eccomerce"
        },
        {
          id: 2,
          name: "POS"
        },
        {
          id: 3,
          name: "ATM"
        }
      ],
      loading: false,
      size: "10px",
      terminalId:'',
      channelId:'',
      id: "",
      index: "",


    };
  },

  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            name: this.name,
            terminalId: this.terminalId,
            channelId: this.channelId,
            type: this.type

          }
          this.makeRequest("post", "v1/update-channel", data).then(
              callResponse => {
                this.loading = false;
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    if (callResponse.response.data.data) {
                      this.$router.push({
                        name: "channel",
                      });
                    }
                  }
                }
              }

          );
        }
      });
    }
  }
};
</script>

